var _defs, _use;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    id: "image11",
    width: 16,
    height: 16,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAA3UlEQVQ4jZWTzW7CQAyEv10WTj1AUd//BUHKuflZDvGUwUklsGTZSTwTez1bgAqU8JpiYbUevqTYmwEqcLC8JoLFfFbuBC0IWiIiAafATOpAfz4Ax3AnYQf8N1bu4AicLHeC0Z41UlEH1UgEvgNDAM7A1cgmYbwDH+MO3Hia8muMovFKXqF8YGsD2w2VulP4kVVeRSI/79ReUk0HuvbuQirAV8TfeP/NOv/IeoCKc0usOl0C8BP5YqDJMc3ad5FIOHtCGo2kN/voChP4PynP4ZsOlL97mboTaBsfXecHcklwQvOnMmIAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image11"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      fill: "rgb(2.745098%,33.333333%,78.823529%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(12.941176%,46.666667%,96.470588%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 11.5 195 C 11.5 198.039062 9.039062 200.5 6 200.5 C 2.960938 200.5 0.5 198.039062 0.5 195 C 0.5 191.960938 2.960938 189.5 6 189.5 C 9.039062 189.5 11.5 191.960938 11.5 195 Z M 11.5 195 ",
    transform: "matrix(0.5,0,0,0.5,5,-89.5)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCircle);
export default __webpack_public_path__ + "static/media/blue_circle.c18d7a13a68318b462700635f81633e0.svg";
export { ForwardRef as ReactComponent };